function formatTextWithLink(html: string): string {
  let result = html.replace(
    /<a /g,
    '<a className="pointer text-info-500 underline" ',
  );
  return result;
}
export default formatTextWithLink;
